import type { ConsentTexts } from '../types';

export const cs: ConsentTexts = {
  eyebrow: 'Soukromí',
  bannerTitle: 'Informace o cookies na této stránce',
  bannerDescription: 'Rádi bychom používali cookies. Umožní nám získat přehled o návštěvnosti webu, lépe cílit reklamu a vylepšovat naše služby.',
  actionsLabel: 'Volby souhlasu s cookies',
  acceptAll: 'Povolit',
  rejectAll: 'Nepovolit',
  settings: 'Nastavení',
  privacyLink: 'Více informací',
  settingsTitle: 'Nastavení cookies',
  settingsDescription: 'Vyberte, ke kterým účelům můžeme cookies používat. Nezbytné cookies jsou zapnuté vždy, protože bez nich web nemůže správně fungovat.',
  saveSelection: 'Uložit nastavení',
  close: 'Zavřít nastavení cookies',
  required: 'Vždy aktivní',
  categories: {
    necessary: {
      name: 'Nezbytné',
      description: 'Zajišťují základní fungování, bezpečnost a dostupnost webu.',
    },
    analytics: {
      name: 'Analytické',
      description: 'Pomáhají nám porozumět používání webu a zlepšovat jeho obsah.',
    },
    marketing: {
      name: 'Marketingové',
      description: 'Umožňují měřit kampaně a zobrazovat relevantnější reklamu.',
    },
    remarketing: {
      name: 'Remarketing',
      description: 'Sledování chování uživatele na webových stránkách s cílem zobrazit reklamu, která je relevantní a zajímavá pro uživatele a tímto hodnotnější pro vydavatele a inzerenty třetích stran.',
    },
    email: {
      name: 'E-mail',
      description: 'Poskytnutí emailové adresy uživatele třetím stranám pro účely lepšího vyhodnocování marketingových aktivit a zobrazování relevantních a zajímavých reklam pro uživatele.',
    },
    preferences: {
      name: 'Preferenční',
      description: 'Pamatují si vaše volby a umožňují přizpůsobit chování webu.',
    },
  },
};
